module.exports = __webpack_public_path__ + "img/logo.af74c371.png";